import { render } from "./ArrowTitle.vue?vue&type=template&id=38dab3c8&scoped=true"
import script from "./ArrowTitle.vue?vue&type=script&lang=js"
export * from "./ArrowTitle.vue?vue&type=script&lang=js"

import "./ArrowTitle.vue?vue&type=style&index=0&id=38dab3c8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38dab3c8"]])

export default __exports__